import { render } from "./BaseCharts.vue?vue&type=template&id=3d574858&scoped=true"
import script from "./BaseCharts.vue?vue&type=script&lang=js"
export * from "./BaseCharts.vue?vue&type=script&lang=js"

import "./BaseCharts.vue?vue&type=style&index=0&id=3d574858&scoped=true&lang=css"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d574858"]])

export default __exports__